import React from 'react';
import  '../../styles/globalStyle.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';

const index = ({ value, onChangeHandler, label, selectedValue, description, dropDownId, dropDownName, showValidation, validationMessage, labelClassName, isLableInfo, tooltipContent, disabledMessage }) => {
  return (
    <>
      <label className={`form-label ${labelClassName ? labelClassName : ''}`}>{label}
        {isLableInfo &&
          <OverlayTrigger
            key="label-info"
            placement="right"
            overlay={
              <Tooltip id="parent-tooltip" className="image-info-tooltip">
                <div dangerouslySetInnerHTML={{ __html: tooltipContent }}></div>
              </Tooltip>
            }>
            <FontAwesomeIcon icon={faCircleQuestion} className="circle-question mx-1" />
          </OverlayTrigger>
        }</label>
      <select
        onChange={(event) => onChangeHandler(event)}
        className={`form-select ${showValidation ? 'border-danger' : ''} ${labelClassName ? labelClassName : ''}`}
        defaultValue={selectedValue}
        value={selectedValue}
        id={dropDownId}>
        {value?.map((item, index) =>
          <option value={item.id} key={index} selected={item.selectedValue} disabled={item.disabled} title={item.disabled && disabledMessage}>
            <>
              {item.name}
              {description &&
                <div className="text-danger">
                  {item.coteacherName != undefined && item.coteacherName.length > 0 && `  (${item.coteacherName})`}
                </div>}
            </>
          </option>
        )}
      </select>
      {showValidation && validationMessage && validationMessage.length > 0 && <p className='text-danger'>{validationMessage}</p>}
      {showValidation && (!validationMessage || validationMessage.length == 0) && <p className='text-danger'>{dropDownName} Is Required.</p>}
    </>
  );
};

export default index;